import IconWithParagraphGridComponent from "./icon-with-paragraph-grid-component";
import IconWithParagraphGridConfig from "./icon-with-paragraph-grid-config";
import IconWithParagraphGridAdvancedConfig from "./icon-with-paragraph-grid-advanced-config";

export default {
  IconWithParagraphGridComponent,
  IconWithParagraphGridConfig,
  IconWithParagraphGridAdvancedConfig
};
